import {ApiInterface} from '../api/api-interface';

/**
 * Comercial «puro»: ROLE_COMERCIAL sin ROLE_EMPLEADO. Con los dos roles manda el de empleado,
 * igual que en la API (Usuario::esComercial()).
 */
export function esComercialPuro(roles: string[]): boolean {
    return roles.includes(ApiInterface.ROLES.COMERCIAL) && !roles.includes(ApiInterface.ROLES.EMPLEADO);
}

/** Si el cliente tiene como comercial al perfil de la sesión. La API decide; esto solo pinta. */
export function esClienteDelComercial(cliente: any, perfil: any): boolean {
    return !!cliente?.comercial && !!perfil && cliente.comercial.id === perfil.id;
}
